document.addEventListener("DOMContentLoaded", () => {
  // Menu toggle (open/close main navigation)
  const menuToggle = document.querySelector(".menu-toggle");
  const menu = document.querySelector("#primary-menu");

  if (menuToggle && menu) {
    menuToggle.addEventListener("click", () => {
      const isExpanded = menuToggle.getAttribute("aria-expanded") === "true";
      menuToggle.setAttribute("aria-expanded", !isExpanded);
      menu.classList.toggle("is-active");
      menuToggle.classList.toggle("is-active");
    });

    menu.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => {
        menu.classList.remove("is-active");
        menuToggle.classList.remove("is-active");
        menuToggle.setAttribute("aria-expanded", false);
      });
    });
  }

  // FAQ toggle
  document.querySelectorAll(".franchise-faqs .faq-item").forEach((item) => {
    const questionWrapper = item.querySelector(".faq-item__question-wrapper");
    const answer = item.querySelector(".faq-item__answer");
    const toggle = item.querySelector(".faq-toggle");

    if (questionWrapper && answer && toggle) {
      const isInitiallyOpen = item.classList.contains("is-expanded");
      answer.classList.toggle("is-open", isInitiallyOpen);

      questionWrapper.style.cursor = "pointer";
      questionWrapper.addEventListener("click", () => {
        const isOpen = item.classList.contains("is-expanded");
        item.classList.toggle("is-expanded", !isOpen);
        toggle.classList.toggle("is-open", !isOpen);
        answer.classList.toggle("is-open", !isOpen);
      });
    }
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      const targetId = this.getAttribute("href").slice(1);
      const target = document.getElementById(targetId);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: "smooth" });
      }
    });
  });

  // ============================================================
  // Testimonials carousel — desktop (auto-advance, infinite loop)
  // ============================================================
  function initTestimonialsCarousel() {
    const containers = document.querySelectorAll('.testimonials__items');

    containers.forEach((container) => {
      const items = container.querySelectorAll('.testimonials__item');

      if (items.length > 3 && window.innerWidth >= 1024) {
        container.classList.add('has-carousel');
        setupInfiniteCarousel(container, items);
      }
    });
  }

  function setupInfiniteCarousel(container, items) {
    const originalItems = Array.from(items);
    originalItems.forEach(item => {
      const clone = item.cloneNode(true);
      container.appendChild(clone);
    });

    let currentPosition = 0;
    let intervalId = null;
    let isPaused = false;

    const itemWidth = 324; // 300px width + 24px gap
    const autoAdvanceDelay = 3000;
    const totalItems = originalItems.length;
    const totalWidth = totalItems * itemWidth;

    function moveToNextPosition() {
      if (!isPaused) {
        currentPosition += itemWidth;

        container.scrollTo({
          left: currentPosition,
          behavior: 'smooth'
        });

        if (currentPosition >= totalWidth) {
          setTimeout(() => {
            currentPosition = 0;
            container.scrollTo({
              left: currentPosition,
              behavior: 'auto'
            });
          }, 500);
        }
      }
    }

    function startAutoAdvance() {
      intervalId = setInterval(moveToNextPosition, autoAdvanceDelay);
    }

    function stopAutoAdvance() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }

    container.addEventListener('mouseenter', () => {
      isPaused = true;
      stopAutoAdvance();
    });

    container.addEventListener('mouseleave', () => {
      isPaused = false;
      startAutoAdvance();
    });

    container.addEventListener('scroll', () => {
      stopAutoAdvance();
      isPaused = true;
      clearTimeout(container.resumeTimeout);
      container.resumeTimeout = setTimeout(() => {
        isPaused = false;
        startAutoAdvance();
      }, 2000);
    });

    startAutoAdvance();

    window.addEventListener('beforeunload', () => {
      stopAutoAdvance();
    });
  }

  initTestimonialsCarousel();
  setTimeout(initTestimonialsCarousel, 1000);

  // ============================================================
  // Testimonials — mobile slider with arrow navigation
  // ============================================================
  function initTestimonialsMobileSlider() {
    if (window.innerWidth > 767) return;

    const blocks = document.querySelectorAll('.testimonials');
    blocks.forEach((block) => {
      const itemsContainer = block.querySelector('.testimonials__items');
      if (!itemsContainer || itemsContainer.dataset.mobileSliderInit) return;

      const items = Array.from(itemsContainer.querySelectorAll('.testimonials__item'));
      if (items.length <= 1) return;

      itemsContainer.dataset.mobileSliderInit = 'true';

      // Create nav and append at the very end of .testimonials
      const nav = document.createElement('div');
      nav.className = 'testimonials__nav';
      const themeUri = (typeof univistaTheme !== 'undefined') ? univistaTheme.themeUri : '';
      nav.innerHTML = `
        <button class="testimonials__prev" aria-label="Previous">
          <img src="${themeUri}/assets/icons/arrow-left.svg" alt="Previous" />
        </button>
        <button class="testimonials__next" aria-label="Next">
          <img src="${themeUri}/assets/icons/arrow-right.svg" alt="Next" />
        </button>
      `;
      block.appendChild(nav);

      // Start on the second video (index 1) so there's one peeking on each side
      let currentIndex = items.length > 2 ? 1 : 0;
      const prevBtn = nav.querySelector('.testimonials__prev');
      const nextBtn = nav.querySelector('.testimonials__next');

      function scrollToItem(index) {
        const item = items[index];
        if (!item) return;

        const containerWidth = itemsContainer.offsetWidth;
        const itemLeft = item.offsetLeft;
        const itemWidth = item.offsetWidth;
        const scrollTarget = itemLeft - (containerWidth / 2) + (itemWidth / 2);

        itemsContainer.scrollTo({
          left: scrollTarget,
          behavior: 'smooth'
        });
      }

      function updateButtons() {
        prevBtn.disabled = currentIndex === 0;
        nextBtn.disabled = currentIndex === items.length - 1;
      }

      prevBtn.addEventListener('click', () => {
        if (currentIndex > 0) {
          currentIndex--;
          scrollToItem(currentIndex);
          updateButtons();
        }
      });

      nextBtn.addEventListener('click', () => {
        if (currentIndex < items.length - 1) {
          currentIndex++;
          scrollToItem(currentIndex);
          updateButtons();
        }
      });

      // Initial position: scroll to the second video
      updateButtons();
      // Small delay so the DOM has laid out before scrolling
      setTimeout(() => scrollToItem(currentIndex), 100);
    });
  }

  initTestimonialsMobileSlider();

  // ============================================================
  // Trusted Carriers — mobile slider with pages
  // ============================================================
  function initCarriersSlider() {
    if (window.innerWidth > 768) return;

    const blocks = document.querySelectorAll('.trusted-carriers');
    blocks.forEach((block) => {
      const logosContainer = block.querySelector('.trusted-carriers__logos');
      if (!logosContainer || logosContainer.dataset.sliderInit) return;

      const logos = Array.from(logosContainer.querySelectorAll('.trusted-carriers__logo'));
      if (logos.length === 0) return;

      logosContainer.dataset.sliderInit = 'true';

      // Group logos into pages of 8 (2 cols × 4 rows)
      const perPage = 8;
      const pages = [];
      for (let i = 0; i < logos.length; i += perPage) {
        pages.push(logos.slice(i, i + perPage));
      }

      // Clear container and build slide pages
      logosContainer.innerHTML = '';
      pages.forEach((pageLogos) => {
        const page = document.createElement('div');
        page.className = 'trusted-carriers__slide-page';
        pageLogos.forEach((logo) => page.appendChild(logo));
        logosContainer.appendChild(page);
      });

      // Only add nav if more than 1 page
      if (pages.length > 1) {
        const oldNav = block.querySelector('.trusted-carriers__nav');
        if (oldNav) oldNav.remove();

        const nav = document.createElement('div');
        nav.className = 'trusted-carriers__nav';
        const themeUri = (typeof univistaTheme !== 'undefined') ? univistaTheme.themeUri : '';
        nav.innerHTML = `
          <button class="trusted-carriers__prev" aria-label="Previous">
            <img src="${themeUri}/assets/icons/arrow-left.svg" alt="Previous" />
          </button>
          <button class="trusted-carriers__next" aria-label="Next">
            <img src="${themeUri}/assets/icons/arrow-right.svg" alt="Next" />
          </button>
        `;

        logosContainer.parentNode.insertBefore(nav, logosContainer.nextSibling);

        let currentPage = 0;
        const prevBtn = nav.querySelector('.trusted-carriers__prev');
        const nextBtn = nav.querySelector('.trusted-carriers__next');

        function updateButtons() {
          prevBtn.disabled = currentPage === 0;
          nextBtn.disabled = currentPage === pages.length - 1;
        }

        prevBtn.addEventListener('click', () => {
          if (currentPage > 0) {
            currentPage--;
            logosContainer.scrollTo({
              left: logosContainer.offsetWidth * currentPage,
              behavior: 'smooth'
            });
            updateButtons();
          }
        });

        nextBtn.addEventListener('click', () => {
          if (currentPage < pages.length - 1) {
            currentPage++;
            logosContainer.scrollTo({
              left: logosContainer.offsetWidth * currentPage,
              behavior: 'smooth'
            });
            updateButtons();
          }
        });

        updateButtons();
      }
    });
  }

  initCarriersSlider();

});
